
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import KMLogo from '../images/Logo.png';
import './Navigation.css';

const Navigation = () => {
  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="navbar-mobile-responsive">
      <Container className="px-3 px-lg-5">
        <Navbar.Brand className="navbar-brand-logo">
          <img src={KMLogo} alt="KM Rafting Adventures" className="d-none d-md-block" style={{ height: '125px', maxHeight: '125px', width: 'auto' }} />
          <img src={KMLogo} alt="KM Rafting Adventures" className="d-md-none" style={{ height: '95px', maxHeight: '95px', width: 'auto' }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className="text-center text-lg-start" style={{ fontSize: '1.5rem' }}>Home</Nav.Link>
            <Nav.Link as={Link} to="/activities" className="text-center text-lg-start" style={{ fontSize: '1.5rem' }}>Activities</Nav.Link>
            <Nav.Link as={Link} to="/gallery" className="text-center text-lg-start" style={{ fontSize: '1.5rem' }}>Gallery</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;